<template>
    <v-list v-if="menu">
        <template v-for="(menuItem, id) in menu" >
            <category-menu v-if="menuItem.children" :menu="menuItem" :key="id" />
            <menu-item v-else :menu="menuItem" :key="id" />
        </template>
    </v-list>
</template>

<script>
import MenuItem from './MenuItem';
import CategoryMenu from './CategoryMenu';

export default {
    components: {
        CategoryMenu,
        MenuItem,
    },
    computed: {
        menu() {
            return this.getMenu()
        },
    },
};
</script>

<style scoped>
.v-list {
    margin-top: 48px;
}
</style>